module.exports = __webpack_public_path__ + "static/media/community.212086f6.svg";